module.exports = __webpack_public_path__ + "img/Architecture_MAP16_AHerzog5-1536x864.5fc12fc7.jpg";